import React, { useEffect, useState } from 'react';
import store from '../../../../../store/store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isChildViewport } from '../../../../../util/isChildViewport';
import {
  createActiveViewportContext,
  setCrossWindowActiveViewport,
} from '../../crossWindow2dReferenceLines';
import { createECGInstanceObject } from './createECGInstanceObject';
import { getDataSet } from '../../../../../services/downloader';
import { StyledWaveformWrapper, StyledLoading } from './styled/ECGStyle';
import PatientInfo from './PatientInfo';
import { PaperLayout } from './PaperLayout';
import { cleanPrefix, WADO_URI_WEB_SERVICE_TYPE, WADO_RS_WEB_SERVICE_TYPE } from '../../../../../util/useServerConfig';
import { getPacsEndpoints } from '../../../../../util/getConfig';

export const Waveform = ({ instanceIds, index }) => {
  const { t } = useTranslation();
  const [fetchECGData, setFetchECGData] = useState([]);
  const { config } = useSelector((state) => state);

  useEffect(() => {
    if (!isChildViewport() || fetchECGData.length === 0) return;
    const layout = store.getState().layout;
    setCrossWindowActiveViewport(index, createActiveViewportContext(layout, index));
  }, [fetchECGData, index]);

  useEffect(() => {
    const url = cleanPrefix(instanceIds[0]); // needed?

    async function dowloadDataSet() {
      const { wadoUriEnabled } = getPacsEndpoints(config);
      const webServiceType = wadoUriEnabled ? WADO_URI_WEB_SERVICE_TYPE : config.WEB_SERVICE_TYPE || WADO_RS_WEB_SERVICE_TYPE;
      const { dataSet } = await getDataSet(url, config.authorizationHeader, webServiceType).then((res) => res);
      const ecgData = createECGInstanceObject(dataSet);
      setFetchECGData(ecgData);
    }
    dowloadDataSet();
  }, [instanceIds]);

  return (
    <StyledWaveformWrapper data-waveform-view-index={index}>
      {fetchECGData.length === 0 ? (
        <StyledLoading>{t('loading')}</StyledLoading>
      ) : (
        <>
          <PatientInfo fetchECGData={fetchECGData} />
          <PaperLayout fetchECGData={fetchECGData} />
        </>
      )}
    </StyledWaveformWrapper>
  );
};
